import { Component, Input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { IntroInfo } from '../../../services/result-data/result-data.service';
import { IntroStateService } from '../../../services/intro-state/intro-state.service';
import { MatIconModule } from '@angular/material/icon';
import { FormatNumbersHtmlPipe } from '../../../pipes/format-numbers-html.pipe';

@Component({
  selector: 'app-intro-menu',
  imports: [MatExpansionModule, MatButtonModule, MatIconModule, FormatNumbersHtmlPipe],
  templateUrl: './intro-menu.component.html',
  styleUrl: './intro-menu.component.scss',
})
export class IntroMenuComponent {
  @Input() infos!: IntroInfo[];
  @Input() modelName = 'Modèle OBIM AZ Hospitalisation';
  @Input() modelVersion = '2.3';

  constructor(private readonly _introStateService: IntroStateService) {}

  onClickButton() {
    this._introStateService.deactivate();
  }
}
